module.exports = __webpack_public_path__ + "img/sld_mfm_inv_5_t1_b1_dark.4ae014f8.svg";